import React, { useEffect } from "react"

const Gallery = ({ isOpen, imageSrc, alt = "", onClose }) => {
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") onClose()
    }

    if (isOpen) {
      document.body.classList.add("lightbox-open")
      window.addEventListener("keydown", handleEsc)
    }

    return () => {
      document.body.classList.remove("lightbox-open")
      window.removeEventListener("keydown", handleEsc)
    }
  }, [isOpen, onClose])

  if (!isOpen) return null

  return (
    <div className="lightbox" onClick={onClose}>
      <div
        className="lightbox__content"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="lightbox__close" onClick={onClose}>
          ×
        </button>
        <img src={imageSrc} alt={alt} />
      </div>
    </div>
  )
}

export default Gallery;
